import ExtensionListContent from "../ExtensionListContent/ExtensionListContent";
import IndividualNavbar from "../IndividualNavbar/IndividualNavbar";

function ExtensionListPage() {
    return (

        <main>
            <section>
                <IndividualNavbar data-testid="individual-navbar" />
            </section>
            <section>
                <ExtensionListContent />
            </section>
        </main>
    )
}

export default ExtensionListPage;